export default "__VITE_ASSET__9c45eea7__"